import { Badge, Flex, Table, TableContainer, Tbody, Th, Thead } from '@chakra-ui/react'
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons'
import { useState } from 'react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { useQuery } from 'react-query'
import { api } from '../../../services/api'
import { Item } from './Item'
import { format } from 'date-fns'

async function getInfoCustomer(codVendedor) {
  const response = await api.get(`/site/v2/crm-controle/chamados-vendedor/${codVendedor}`)
  return response.data
}

async function listCustomers() {
  const response = await api.get('/site/v2/controle-rodizio/lista-fila-vendedores')

  const sorted = response.data.sort((a, b) => {
    if (a.ultimo_chamado && b.ultimo_chamado) {
      return new Date(b.ultimo_chamado) - new Date(a.ultimo_chamado)
    }
    return 0
  })

  const data = await Promise.all(
    sorted.map(async (vendedor) => {
      const info = await getInfoCustomer(vendedor.codigo_vendedor)
      const ultimoChamado = info?.ultimo_chamado ? format(new Date(info.ultimo_chamado), 'dd/MM/yyyy HH:mm') : ''

      return {
        ...vendedor,
        ...info,
        nome_vendedor: vendedor.nome_vendedor.toLowerCase(),
        ultimo_chamado: vendedor.ultimo_chamado ? format(new Date(vendedor.ultimo_chamado), 'dd/MM/yyyy HH:mm') : 'Não tem',
      }
    })
  )

  return data
}

function sortData(data, key, direction) {
  if (!key) {
    return data
  }

  return data.sort((a, b) => {
    //transforma em numero, se for string
    const valueA = isNaN(a[key]) ? a[key] : Number(a[key])
    const valueB = isNaN(b[key]) ? b[key] : Number(b[key])

    if (valueA < valueB) {
      return direction === 'asc' ? -1 : 1
    }
    if (valueA > valueB) {
      return direction === 'asc' ? 1 : -1
    }
    return 0
  })
}

export function ControleDeFila() {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' })

  const { data: vendedores } = useQuery({
    queryKey: 'controle-rodizio',
    queryFn: listCustomers,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
  })

  const handleSort = (key) => {
    let direction = 'asc'
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }

  return (
    <>
      <HeadingPages name="Controle de Fila" />

      <Layout>
        <Flex flexDir="column" gap={2} mb={2}>
          Informações:
          <Flex gap={2}>
            <Badge bg="red.100">Desativado</Badge>
            <Badge bg="yellow.100">Agendado para desativar</Badge>
            <Badge bg="green.100">Ativo</Badge>
          </Flex>
        </Flex>
        <TableContainer>
          <Table colorScheme="blackAlpha">
            <Thead bg="gray.100">
              <Th>Vendedor</Th>
              <Th>Último chamado</Th>
              <Th>Fila</Th>
              <Th textAlign="end">Desativar por Período</Th>
              <Th textAlign="end">Desligar Vendedor</Th>
              <Th>Ativar</Th>
              <Th textAlign="end">Retornar Padrão</Th>

              <Th cursor="pointer" textAlign="end" onClick={() => handleSort('chamados_dia')}>
                Chamados dia
                {sortConfig.direction === 'asc' ? <ChevronUpIcon fontSize="lg" /> : <ChevronDownIcon fontSize="lg" />}
              </Th>
              <Th cursor="pointer" textAlign="end" onClick={() => handleSort('chamados_semanal')}>
                Chamados Semana
                {sortConfig.direction === 'asc' ? <ChevronUpIcon fontSize="lg" /> : <ChevronDownIcon fontSize="lg" />}
              </Th>
              <Th cursor="pointer" textAlign="end" onClick={() => handleSort('chamados_mes')}>
                Chamados Mês
                {sortConfig.direction === 'asc' ? <ChevronUpIcon fontSize="lg" /> : <ChevronDownIcon fontSize="lg" />}
              </Th>
            </Thead>
            <Tbody>
              {vendedores &&
                sortData(vendedores, sortConfig.key, sortConfig.direction).map((vendedor) => (
                  <Item key={vendedor.codigo_vendedor} vendedor={vendedor} />
                ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Layout>
    </>
  )
}
